import { ChevronRightRounded } from '@mui/icons-material'
import { Button, Fade, Paper, Popper, PopperPlacementType, Typography } from '@mui/material'
import { MouseEvent, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'

export default function ModalInfo({ title = [], options = [] }: any) {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  const [open, setOpen] = useState(false)
  const [placement, setPlacement] = useState<PopperPlacementType>()

  const handleClick = (newPlacement: PopperPlacementType) => (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
    setOpen(prev => placement !== newPlacement || !prev)
    setPlacement(newPlacement)
  }

  return (
    <>
      <Popper open={open} anchorEl={anchorEl} placement={placement} transition style={{ maxHeight: 160 }}>
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper
              sx={theme => ({
                maxHeight: 150,
                overflow: 'auto',
                padding: 4,
                paddingLeft: 16,
                paddingRight: 16,
                maxWidth: 280,
                '&::-webkit-scrollbar': {
                  backgroundColor: theme.palette.grey[200],
                  borderRadius: '4px',
                  width: '10px',
                  margin: '8px',
                  paddingRight: 10,
                  '&-thumb': {
                    backgroundColor: theme.palette.grey[500],
                    borderRadius: '4px'
                  }
                }
              })}
            >
              {options.length > 0 ? (
                options.map((option: any) => {
                  return <Typography key={uuidv4()}>{option.name ? option.name : null}</Typography>
                })
              ) : (
                <Typography>{options.name}</Typography>
              )}
            </Paper>
          </Fade>
        )}
      </Popper>

      <Button
        sx={theme => ({
          fontSize: '1rem',
          color: theme.palette.grey[500],
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-start'
        })}
        startIcon={<ChevronRightRounded />}
        style={{ paddingLeft: 0 }}
        onClick={handleClick('bottom-start')}
      >
        <Typography>{title}</Typography>
      </Button>
    </>
  )
}
